module.exports = __webpack_public_path__ + "static/media/usyd_logo2.e317e831.png";